import React from 'react';
import { string } from 'prop-types';
import { ButtonNormalLink } from './BlueButton.style';

const BlueButton = ({
    content,
    maxWidth,
    minWidth,
    color,
    margin,
    width,
    fontSize,
    padding,
    minHeight,
    shadow,
    to
}) => {
    return (
        <ButtonNormalLink
            width={width}
            maxwidth={maxWidth}
            minwidth={minWidth}
            color={color}
            margin={margin}
            fontSize={fontSize}
            minheight={minHeight}
            padding={padding}
            shadow={shadow}
            href={to}
            rel="noopener noreferrer"
            target="_blank"
        >
            {content}
        </ButtonNormalLink>
    );
};

BlueButton.propTypes = {
    content: string.isRequired,
    maxWidth: string,
    minWidth: string,
    color: string,
    margin: string,
    width: string,
    fontSize: string,
    minHeight: string,
    padding: string,
    shadow: string,
    to: string
};

BlueButton.defaultProps = {
    minWidth: '',
    color: '#1B2555',
    margin: '0',
    width: '',
    fontSize: '14px',
    minHeight: 'unset',
    padding: '17px 23px',
    shadow: 'unset'
};

export default BlueButton;